import { isSsr } from './NetworkUtil';
import { windowExists } from '../components/Utils';

export const getAuthorizationToken = (): string =>
  !isSsr ? window.THDCustomer?.default?.token || '' : '';

export const getSvocId = (): string | null =>
  isSsr ? null : window.THDCustomer?.default?.svocID || '';

export const getUserId = (): string | null =>
  isSsr ? null : window.THDCustomer?.default?.userID || '';

export const getMemberId = (): string | null => {
  if (isSsr) return null;

  const token = getAuthorizationToken();
  const svocId = getSvocId();

  if (token && svocId) return svocId;

  return window.THDCustomer?.default?.userID || '';
};

export const isLoggedIn = (): boolean =>
  windowExists() && (window.THDCustomer?.default?.isLoggedIn || false);

export const isB2BUser = (): boolean =>
  windowExists() && (window.THDCustomer?.default?.isB2BCustomer || false);
